import { Component, inject } from '@angular/core';
import { Modal, NonPersistedModalName, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-info-game-trophies-modal',
  standalone: true,
  templateUrl: './info-game-trophies-modal.component.html',
  styleUrl: './info-game-trophies-modal.component.scss',
  imports: [SharedModule],
})
export class InfoGameTrophiesModalComponent {
  private readonly eventManager = inject(EventManager);

  closeInfo() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.InfoGameTrophiesModalComponent, ModalType.View));
  }
}
